<template>
  <div id="app">
    <meta name="viewport"
    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />
    <Car />
  </div>
</template>

<script>
import Car from '@/views/Car.vue';

export default {
  name: 'App',
  components: {
    Car,
  },
};
</script>

<style lang="scss">
@import url('https://phont.io/vw/fonts.css');
html{
  touch-action: none;
  overflow: hidden;
  background: #4d4d4d;
}
body {
  margin: 0;
}
::-webkit-scrollbar{
  display: none;
}
</style>
